import ABTestSection from '../blocks/ABTestSection/ABTestSection.esm.js';
import AccordionSectionItem from '../blocks/AccordionSection/AccordionSectionItem/AccordionSectionItem.esm.js';
import AccordionSection from '../blocks/AccordionSection/AccordionSection.esm.js';
import '../blocks/ComponentBlock/ComponentBlockContext.esm.js';
import ComponentBlock from '../blocks/ComponentBlock/ComponentBlock.esm.js';
import '../blocks/AtomSection/AtomSectionContext.esm.js';
import AtomSection from '../blocks/AtomSection/AtomSection.esm.js';
import BannerActionBlock from '../blocks/BannerActionBlock/BannerActionBlock.esm.js';
import BannerBlock from '../blocks/BannerBlock/BannerBlock.esm.js';
import BannerFactBlock from '../blocks/BannerFactBlock/BannerFactBlock.esm.js';
import CarouselSection from '../blocks/CarouselSection/CarouselSection.esm.js';
import ColumnSectionItem from '../blocks/ColumnsSection/ColumnSectionItem/ColumnSectionItem.esm.js';
import ColumnsSection from '../blocks/ColumnsSection/ColumnsSection.esm.js';
import CustomerReviewSection from '../blocks/CustomerReviewSection/CustomerReviewSection.esm.js';
import FootnoteSection from '../blocks/FootnoteSection/FootnoteSection.esm.js';
import FooterBlock from '../blocks/FooterBlock/FooterBlock.esm.js';
import { HeroBlock } from '../blocks/HeroBlock/HeroBlock.esm.js';
import HeroBoxBlock from '../blocks/HeroBoxBlock/HeroBoxBlock.esm.js';
import HeroShapeBlock from '../blocks/HeroShapeBlock/HeroShapeBlock.esm.js';
import HeroTextBlock from '../blocks/HeroTextBlock/HeroTextBlock.esm.js';
import IconCardSectionItem from '../blocks/IconCardSection/IconCardSectionItem/IconCardSectionItem.esm.js';
import IconCardSection from '../blocks/IconCardSection/IconCardSection.esm.js';
import IconGridItem from '../blocks/IconGridSection/IconGridItem/IconGridItem.esm.js';
import IconGrid from '../blocks/IconGridSection/IconGrid.esm.js';
import List from '../blocks/ListWithIconBulletsSection/ListWithIconBulletsSectionItem/ListWithIconBulletsSectionItem.esm.js';
import ListWithIconBulletsSection from '../blocks/ListWithIconBulletsSection/ListWithIconBulletsSection.esm.js';
import LogosSection from '../blocks/LogosSection/LogosSection.esm.js';
import ProductCardSectionItem from '../blocks/ProductCardSection/components/ProductCardSectionItem.esm.js';
import ProductCardSection from '../blocks/ProductCardSection/ProductCardSection.esm.js';
import StepperHoverItem from '../blocks/StepperHoverSection/StepperHoverItem/StepperHoverItem.esm.js';
import StepperHoverSection from '../blocks/StepperHoverSection/StepperHoverSection.esm.js';
import StepperStaticItem from '../blocks/StepperStaticSection/StepperStaticItem/StepperStaticItem.esm.js';
import StepperStaticSection from '../blocks/StepperStaticSection/StepperStaticSection.esm.js';
import TabsSection from '../blocks/TabsSection/TabsSection.esm.js';
import TechSpecSectionItem from '../blocks/TechSpecSection/TechSpecSectionItem/TechSpecSectionItem.esm.js';
import TechSpecSection from '../blocks/TechSpecSection/TechSpecSection.esm.js';
import TextAndMediaSection from '../blocks/TextAndMediaSection/TextAndMediaSection.esm.js';
import TeamBlock from '../blocks/TeamBlock/TeamBlock.esm.js';
import ListOfLinksBlock from '../blocks/ListOfLinksBlock/ListOfLinksBlock.esm.js';
import ListOfLinksItem from '../blocks/ListOfLinksBlock/ListOfLinksSection/ListOfLinksItem/ListOfLinksItem.esm.js';
import ListOfLinksSection from '../blocks/ListOfLinksBlock/ListOfLinksSection/ListOfLinksSection.esm.js';
import NucleobaseTab from '../blocks/TabsSection/Tab/Tab.esm.js';
import { BaseLink } from '../common/BaseLink/BaseLink.esm.js';
import { Link } from '../common/Link/Link.esm.js';
import ShapeComponent from '../common/ShapeComponent/ShapeComponent.esm.js';
import WrappedImage from '../common/WrappedImage/WrappedImage.esm.js';
import WrappedVideo from '../common/WrappedVideo/WrappedVideo.esm.js';
import Page from '../Page/Page.esm.js';
import { ContentfulModels } from '@invitae/contentful-types';

var _a;
var contentfulComponentsMap = (_a = {},
    _a[ContentfulModels.externalLink] = BaseLink,
    _a[ContentfulModels.internalLink] = BaseLink,
    _a[ContentfulModels.patientTestLink] = BaseLink,
    _a[ContentfulModels.videoPopupLink] = BaseLink,
    _a[ContentfulModels.actionLink] = BaseLink,
    _a[ContentfulModels.abTestSection] = ABTestSection,
    _a[ContentfulModels.accordionItem] = AccordionSectionItem,
    _a[ContentfulModels.accordionSection] = AccordionSection,
    _a[ContentfulModels.componentBlock] = ComponentBlock,
    _a[ContentfulModels.atomSection] = AtomSection,
    _a[ContentfulModels.bannerSection] = BannerBlock,
    _a[ContentfulModels.columnsSection] = ColumnsSection,
    _a[ContentfulModels.footnoteSection] = FootnoteSection,
    _a[ContentfulModels.footerBlock] = FooterBlock,
    _a[ContentfulModels.heroImageSection] = HeroBlock,
    _a[ContentfulModels.heroTextBoxSection] = HeroBoxBlock,
    _a[ContentfulModels.heroTextSection] = HeroTextBlock,
    _a[ContentfulModels.iconGrid] = IconGrid,
    _a[ContentfulModels.iconGridItem] = IconGridItem,
    _a[ContentfulModels.image] = WrappedImage,
    _a[ContentfulModels.leadspaceWithShape] = HeroShapeBlock,
    _a[ContentfulModels.link] = Link,
    _a[ContentfulModels.page] = Page,
    _a[ContentfulModels.sectionCarousel] = CarouselSection,
    _a[ContentfulModels.sectionColumnsItem] = ColumnSectionItem,
    _a[ContentfulModels.sectionCustomerReview] = CustomerReviewSection,
    _a[ContentfulModels.sectionFactBanner] = BannerFactBlock,
    _a[ContentfulModels.sectionIconCards] = IconCardSection,
    _a[ContentfulModels.sectionIconCardsItem] = IconCardSectionItem,
    _a[ContentfulModels.sectionListWithIconBullets] = ListWithIconBulletsSection,
    _a[ContentfulModels.sectionListWithIconBulletsItem] = List,
    _a[ContentfulModels.sectionLogos] = LogosSection,
    _a[ContentfulModels.sectionNextActionBanner] = BannerActionBlock,
    _a[ContentfulModels.sectionProductCardsItem] = ProductCardSectionItem,
    _a[ContentfulModels.sectionProductCards] = ProductCardSection,
    _a[ContentfulModels.sectionStepperHover] = StepperHoverSection,
    _a[ContentfulModels.sectionStepperHoverItem] = StepperHoverItem,
    _a[ContentfulModels.sectionStepperStatic] = StepperStaticSection,
    _a[ContentfulModels.sectionStepperStaticItem] = StepperStaticItem,
    _a[ContentfulModels.textAndMediaSection] = TextAndMediaSection,
    _a[ContentfulModels.decorativeShape] = ShapeComponent,
    _a[ContentfulModels.sectionTechSpec] = TechSpecSection,
    _a[ContentfulModels.sectionTechSpecItem] = TechSpecSectionItem,
    _a[ContentfulModels.tabsSection] = TabsSection,
    _a[ContentfulModels.tabsSectionItem] = NucleobaseTab,
    _a[ContentfulModels.video] = WrappedVideo,
    _a[ContentfulModels.listOfLinksBlock] = ListOfLinksBlock,
    _a[ContentfulModels.listOfLinksSection] = ListOfLinksSection,
    _a[ContentfulModels.listOfLinksItem] = ListOfLinksItem,
    _a[ContentfulModels.teamsBlock] = TeamBlock,
    _a);

export { contentfulComponentsMap as default };
//# sourceMappingURL=defaultMap.esm.js.map
